/*
  Sequoia Soothe cart drawer helpers.

  1. window.sqRefreshCartDrawer()
     Re-renders the cart drawer and header cart icon from the server, then opens
     the drawer. The custom buy boxes call this after a successful add instead of
     sending the shopper to /cart.

  2. Upgrade card ("Move up to the 3 month supply", snippets/cart-upgrade-offer.liquid)
     One click adds the bigger plan, removes the 1 month line, and re-renders.

  XMLHttpRequest is used on purpose. Appstle patches window.fetch on product pages
  and strips selling_plan from /cart/add.js (see snippets/custom-buy-box.liquid).
*/
(function () {
  if (window.__sqCartUpgradeLoaded) return; // included by both the drawer and the cart page
  window.__sqCartUpgradeLoaded = true;
  function request(method, url, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      xhr.setRequestHeader('Accept', 'application/json');
      if (body) xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.timeout = 20000;
      xhr.onload = function () {
        var data = null;
        try { data = JSON.parse(xhr.responseText); } catch (e) {}
        if (xhr.status >= 200 && xhr.status < 300) { resolve(data); return; }
        var message = (data && (data.description || data.message)) || 'Something went wrong. Please try again.';
        reject(new Error(message));
      };
      xhr.onerror = function () { reject(new Error('Something went wrong. Please try again.')); };
      xhr.ontimeout = function () { reject(new Error('That took too long. Please try again.')); };
      xhr.send(body ? JSON.stringify(body) : null);
    });
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function refreshDrawer() {
    var drawer = getDrawer();
    if (!drawer || typeof drawer.renderContents !== 'function') {
      return Promise.reject(new Error('Cart drawer is not on this page.'));
    }
    return request('GET', '/?sections=cart-drawer,cart-icon-bubble').then(function (sections) {
      if (!sections || !sections['cart-drawer']) throw new Error('Could not load the cart.');
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var isEmpty = !!doc.querySelector('cart-drawer.is-empty');
      drawer.classList.toggle('is-empty', isEmpty);
      drawer.renderContents({ sections: sections });
    });
  }

  window.sqRefreshCartDrawer = refreshDrawer;

  // Free-gift guard.
  //
  // The buy box adds the gift products (window.sqGiftVariants, from
  // snippets/sq-gift-guard.liquid) alongside a subscription line; an automatic
  // Buy X get Y discount makes them $0. If the shopper removes the subscription,
  // the discount would stop applying and the gifts would become full price, so
  // strip them whenever the cart has gifts but no subscription line.
  function giftsForPlan(planId) {
    var map = window.sqGiftMap || {}, plans = window.sqGiftPlans || {};
    return (plans[String(planId)] || []).map(function (h) { return Number(map[h]); }).filter(Boolean);
  }
  var giftGuardBusy = false;
  function giftGuard() {

    var gifts = (window.sqGiftVariants || []).map(Number).filter(Boolean);
    if (!gifts.length || giftGuardBusy) return Promise.resolve(false);
    giftGuardBusy = true;
    return request('GET', '/cart.js').then(function (cart) {
      var items = (cart && cart.items) || [];
      // Allowed gifts = union of what every subscription line in the cart earns (window.sqGiftPlans),
      // and only for carts stamped by the v2 page (cart attribute pdp_version=v2).
      var allowed = [];
      var isV2 = !!(cart && cart.attributes && cart.attributes.pdp_version === 'v2');
      if (isV2) items.forEach(function (it) {
        var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
        if (sp) { giftsForPlan(sp.id).forEach(function (id) { if (allowed.indexOf(id) === -1) allowed.push(id); }); }
      });
      var updates = {};
      items.forEach(function (it) {
        var vid = Number(it.variant_id);
        if (gifts.indexOf(vid) === -1) return;
        if (allowed.indexOf(vid) === -1 || Number(it.final_line_price) > 0) { updates[it.key] = 0; } // not earned by this plan, or not free: remove
        else if (Number(it.quantity) > 1) { updates[it.key] = 1; }                                  // one of each gift, never more
      });

      if (!Object.keys(updates).length) return false;

      return request('POST', '/cart/update.js', { updates: updates }).then(function () { return true; });
    }).catch(function () { return false; }).then(function (changed) {
      giftGuardBusy = false;
      if (changed) {
        if (getDrawer()) { refreshDrawer().catch(function () {}); }
        else { window.location.reload(); } /* full cart page: re-render by reloading */
      }
      return changed;
    });
  }
  window.sqGiftGuard = giftGuard;

  // Drawer checkout button: Shop Pay only.
  //
  // Shopify renders every enabled wallet (Shop Pay, PayPal, Google Pay) from the
  // wallet-configs attribute of <shopify-accelerated-checkout-cart>. Re-creating
  // the element with just the shop_pay config renders a single full-width button.
  //
  // Section Rendering API responses (used when the drawer refreshes after an add
  // or a quantity change) leave content_for_additional_checkout_buttons empty, so
  // the element only exists after a full page load. When it is missing, fetch the
  // cart page, borrow the element from there, and inject it.
  var shopPayFetchInFlight = false;

  function buildShopPayOnly(source) {
    var configs;
    try { configs = JSON.parse(source.getAttribute('wallet-configs') || '[]'); } catch (e) { return null; }
    var shopPay = configs.filter(function (w) { return w && w.name === 'shop_pay'; });
    if (!shopPay.length) return null;
    var fresh = document.createElement('shopify-accelerated-checkout-cart');
    for (var i = 0; i < source.attributes.length; i++) {
      fresh.setAttribute(source.attributes[i].name, source.attributes[i].value);
    }
    fresh.setAttribute('wallet-configs', JSON.stringify(shopPay));
    fresh.dataset.sqShopPayOnly = 'true';
    return fresh;
  }

  function fetchText(url) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Accept', 'text/html');
      xhr.timeout = 20000;
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) resolve(xhr.responseText);
        else reject(new Error('HTTP ' + xhr.status));
      };
      xhr.onerror = function () { reject(new Error('network')); };
      xhr.ontimeout = function () { reject(new Error('timeout')); };
      xhr.send(null);
    });
  }

  function ensureDrawerShopPay() {
    var drawer = getDrawer();
    if (!drawer || drawer.classList.contains('is-empty')) return;
    var wrap = drawer.querySelector('.cart__dynamic-checkout-buttons');
    if (!wrap) return;
    var el = wrap.querySelector('shopify-accelerated-checkout-cart');

    if (el) {
      if (el.dataset.sqShopPayOnly) return;
      var fresh = buildShopPayOnly(el);
      if (fresh) el.replaceWith(fresh);
      else el.dataset.sqShopPayOnly = 'none';
      return;
    }

    if (shopPayFetchInFlight) return;
    shopPayFetchInFlight = true;
    fetchText((window.routes && routes.cart_url) || '/cart')
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('shopify-accelerated-checkout-cart');
        if (!source) return;
        var current = getDrawer();
        var target = current && current.querySelector('.cart__dynamic-checkout-buttons');
        if (!target || target.querySelector('shopify-accelerated-checkout-cart')) return;
        var built = buildShopPayOnly(source);
        if (!built) return;
        var inner = target.querySelector('.dynamic-checkout__content') || target;
        inner.innerHTML = '';
        inner.appendChild(built);
      })
      .catch(function () {})
      .then(function () { shopPayFetchInFlight = false; });
  }

  function watchDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    ensureDrawerShopPay();
    var guardTimer;
    new MutationObserver(function () {
      ensureDrawerShopPay();
      clearTimeout(guardTimer);
      guardTimer = setTimeout(giftGuard, 400);
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    giftGuard();
  }
  function watchCartPage() {
    var page = document.querySelector('cart-items');
    if (!page || getDrawer()) return;
    giftGuard();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(giftGuard, 400); })
      .observe(page, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watchDrawer(); watchCartPage(); });
  } else {
    watchDrawer(); watchCartPage();
  }

  document.addEventListener('click', function (evt) {
    var button = evt.target.closest ? evt.target.closest('[data-sq-upgrade]') : null;
    if (!button || button.disabled) return;

    var card = button.closest('[data-sq-upgrade-card]');
    var errorEl = card ? card.querySelector('.sq-upgrade__error') : null;
    var label = button.querySelector('.sq-upgrade__cta-label');
    var loading = button.querySelector('.sq-upgrade__cta-loading');

    function setBusy(on) {
      button.disabled = on;
      if (label) label.hidden = on;
      if (loading) loading.hidden = !on;
    }
    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    var item = {
      id: Number(button.dataset.addId),
      quantity: Number(button.dataset.addQty) || 1,
    };
    if (button.dataset.addPlan) item.selling_plan = Number(button.dataset.addPlan);
    var removeKey = button.dataset.removeKey;

    if (!item.id || !removeKey) return;
    if (errorEl) errorEl.hidden = true;
    setBusy(true);

    var gifts = item.selling_plan ? giftsForPlan(item.selling_plan) : [];
    request('GET', '/cart.js')
      .then(function (cart) {
        var items = [item];
        var isV2 = !!(cart && cart.attributes && cart.attributes.pdp_version === 'v2');
        if (isV2 && item.selling_plan && gifts.length) {


          var have = ((cart && cart.items) || []).map(function (it) { return Number(it.variant_id); });
          gifts.forEach(function (gid) { if (have.indexOf(gid) === -1) items.push({ id: gid, quantity: 1 }); });
        }
        return request('POST', '/cart/add.js', { items: items });
      })
      .then(function () {
        return request('POST', '/cart/change.js', { id: removeKey, quantity: 0 });
      })
      .then(function () {
        return refreshDrawer();
      })
      .catch(function (err) {
        setBusy(false);
        showError(err.message);
        // Show whatever state the cart is really in.
        refreshDrawer().catch(function () {});
      });
  });
})();
